import { useContext } from 'react';

/**
 * Creates a custom hook for consuming React context with error handling
 * 
 * @param {React.Context} context - The React context object to consume
 * @param {string} hookName - Name of the hook for error messaging
 * @returns {Function} Custom hook that returns context value with error checking
 */
export const createContextHook = (context, hookName) => {
  return () => {
    const ctx = useContext(context); // Get context value using React's useContext hook
    if (!ctx) { // Throw error if context is used outside of provider
      throw new Error(`${hookName} must be used within its corresponding provider`);
    }
    // Return the context value if valid
    return ctx;
  };
};